
<div class="list">
  
  <div class="d-flex flex-wrap" v-if="!status.loading && items.length > 0">
    <div :class="`item ${colClass[componentClass] ? colClass[componentClass] : colClass.default}`" v-for="(item, index) in filteredItems" :key="index">
      <template v-if="componentName === 'Blog'">
        <BlogItem :item="item" :configTexts="configTexts" :locale="locale"/>
      </template>

      <template v-else-if="componentName === 'Promotions'">
        <PromotionItem :item="item" :configTexts="configTexts" :locale="locale" :contentVersionID="contentVersionID"/>
      </template>

      <template v-else-if="componentName === 'Catalog'">
        <CatalogItem class="bg-white d-flex justify-content-between flex-column h-100" :item="item" :configTexts="configTexts" :locale="locale" :contentVersionID="contentVersionID"/>
      </template>

      <template v-else-if="componentName === 'Services'">
        <ServiceItem :item="item" :configTexts="configTexts" :locale="locale" :contentVersionID="contentVersionID"/>
      </template>

      <template v-else>
        <DefaultItem :item="item" :configTexts="configTexts" :locale="locale"/>
      </template>
    </div>
  </div>

  <div class="w-100" v-else-if="status.loading">
    <Skeleton :component="componentName.toLowerCase()" />
  </div>

  <div class="d-flex place-content-center" v-else>
    <div class="text-center-2">
      <img class="img-not-found" src="https://asurcloudrunprod-16905.kxcdn.com/public-assets/icon-notfound" width="200" height="185"/>
      <p class="fw-bold mt-2">{{$locale === 'es' ? 'No se encontraron resultados para tu búsqueda' : 'No results were found for your search'}}</p>
    </div>
  </div>
</div>
